<template>
  <div class="wrapper">
    <AppContent />
    <AppAudio v-for="sound in sounds" :key="sound.id" :id="sound.id" />
    <AppSoundSwitcher v-if="currentStep.id < 2" />
    <img class="answer-image" src="@/assets/images/answer-img1.png" alt="image description" aria-hidden="true">
    <img class="answer-image" src="@/assets/images/answer-img2.png" alt="image description" aria-hidden="true">
    <img class="answer-image" src="@/assets/images/answer-img3.png" alt="image description" aria-hidden="true">
    <img class="answer-image" src="@/assets/images/answer-img4.png" alt="image description" aria-hidden="true">
    <img class="answer-image" src="@/assets/images/intro-bg.jpg" alt="image description" aria-hidden="true">
    <img class="answer-image" src="@/assets/images/second-bg.png" alt="image description" aria-hidden="true">
    <img class="answer-image" src="@/assets/images/final-bg.png" alt="image description" aria-hidden="true">
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import AppContent from '@/components/Content'
  import AppAudio from '@/components/Audio'
  import AppSoundSwitcher from '@/components/elements/SoundSwitcher'

  export default {
    name: 'App',
    components: {
      AppContent,
      AppAudio,
      AppSoundSwitcher
    },
    computed: {
      ...mapGetters({
        sounds: 'getSounds',
        currentStep: 'getCurrentStep'
      })
    },
    mounted() {
      function vh() {
        document.documentElement.style.setProperty('--full-viewport', `${window.innerHeight}px`);
      }
      vh();
      window.addEventListener('resize', vh);
      window.addEventListener('orientationchange', vh);
    },
    unmounted() {
      window.removeEventListener("resize", this.getTableHeight);
    },
  }
</script>
